import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import {FormItemRuleTitle} from '../BDLOGIC/FormChooseBdlogic.jsx'

export default function FormChooseBdlogic(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemRuleTitle />
        </FormChooseExternal>
    )
}
